import React from 'react';

import { Container, Stack, Text } from '@mantine/core';
import { IconArrowNarrowDown } from '@tabler/icons-react';

import GLMFlowBuilderCard, { GLMFlowBuilderCardType } from './GLMFlowBuilderCard';

export interface BuilderCard {
  key: string;
  cardType: GLMFlowBuilderCardType;
  headerLabel: string;
  value?: string | null;
  placeholderText?: string;
  isSelected?: boolean;
}

interface GLMFlowBuilderMainContainerProps {
  cards: BuilderCard[];
}

// Shared visual flow panel for both GLM flow builders (Kilo→GLM and GLM→Kilo).
// Each builder computes the ordered `cards` from its own form state + labels;
// this component only handles layout: an empty dashed prompt until the first
// card exists, then a vertical trigger → … → action stack joined by arrows.
const GLMFlowBuilderMainContainer = ({ cards }: GLMFlowBuilderMainContainerProps): JSX.Element => (
  <Container style={{ display: 'flex', height: '100vh', justifyContent: 'center' }}>
    <Stack
      justify='flex-start'
      sx={theme => ({
        paddingTop: '5rem',
        width: '95vw',
        [theme.fn.largerThan('sm')]: { width: '75vw' },
        [theme.fn.largerThan('md')]: { width: '55vw' },
        [theme.fn.largerThan('lg')]: { width: '40vw' },
        [theme.fn.largerThan('xl')]: { width: '30vw' },
      })}
    >
      {cards.length === 0 ? (
        <Stack align='center' style={{ width: '100%' }}>
          <div
            style={{
              width: '90%',
              padding: '24px',
              border: '2px dashed #ced4da',
              borderRadius: 8,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Text color='dimmed' align='center'>
              Your automation will appear here as you build it.
            </Text>
          </div>
        </Stack>
      ) : (
        cards.map((card, index) => (
          <Stack key={card.key} align='center' style={{ width: '100%' }}>
            {index > 0 && <IconArrowNarrowDown size={20} />}
            <GLMFlowBuilderCard
              cardType={card.cardType}
              headerLabel={card.headerLabel}
              value={card.value}
              placeholderText={card.placeholderText}
              isSelected={card.isSelected}
            />
          </Stack>
        ))
      )}
    </Stack>
  </Container>
);

export default GLMFlowBuilderMainContainer;
